import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Panel} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED, sendCreateOpeningTicketInstructionAction, loadOpeningTicketInstructionStream} from '../actions'
import {CreateOpeningTicketInstructionAction} from '../models'
import i18n from '../i18n'
import style from './CreateOpeningTicketInstructionPanel.less'

class CreateOpeningTicketInstructionPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _sendAction(event) {
        const {dispatch, onSelect} = this.props

        var openingTicketInstructionUid
        return dispatch(sendCreateOpeningTicketInstructionAction()).then((action) => {
            openingTicketInstructionUid = action.openingTicketInstructionUid
            return dispatch(loadOpeningTicketInstructionStream())
        }).then(() => {
            onSelect(event, openingTicketInstructionUid)
        })
    }

    render() {
        const {dispatch, form, action, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Panel
                {...others}>
                <div className={style.defaultContent}>
                    <h4>{i18n.newOpeningTicketInstruction}</h4>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='title'
                            label={requiredLabel(i18n.title)}
                            {...form.title()} />
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='textarea'
                            name='text'
                            label={requiredLabel(i18n.text)}
                            {...form.text()} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={(e) => form.validate() && this._sendAction(e) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                    </ButtonToolbar>
                </div>
            </Panel>
        )
    }
}

CreateOpeningTicketInstructionPanel = connectForm({
    target: 'action',
    schema: CreateOpeningTicketInstructionAction.schema,
    action: CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
})(CreateOpeningTicketInstructionPanel)

CreateOpeningTicketInstructionPanel = connect((state) => ({
    action: state.message.createOpeningTicketInstructionAction
}))(CreateOpeningTicketInstructionPanel)

export default CreateOpeningTicketInstructionPanel


// WEBPACK FOOTER //
// ./lib/message/components/CreateOpeningTicketInstructionPanel.js